import { createVanIconComponent } from "./van"

const Cart = createVanIconComponent("cart")
export default Cart
